export default function oryRedirect(origin: string | undefined, path: string) {
  if (!origin) {
    console.error("Ory origin is not defined");
    return;
  }
  window.location.href = `${origin}${path}`;
}
